import React from "react";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import EnginesMatrix from "@/components/EnginesMatrix";
import LiveDemo from "@/components/LiveDemo";
import CaseStudy from "@/components/CaseStudy";
import EmpowermentTimeline from "@/components/EmpowermentTimeline";
import Pricing from "@/components/Pricing";
import FrictionAudit from "@/components/FrictionAudit";
import Founder from "@/components/Founder";

const HomePage = () => (
  <>
    <Hero />
    <TrustBar />
    <EnginesMatrix />
    <LiveDemo />
    <CaseStudy />
    <EmpowermentTimeline />
    <Pricing />
    <FrictionAudit />
    <Founder />
  </>
);

export default HomePage;
